import {
  GET_ORDERS,
  FILTER_ORDERS,
  SORT_ORDERS,
  GET_SERIAL_NUMBERS,
  SORT_SERIAL_NUMBERS,
  FILTER_SERIAL_NUMBERS,
  GET_DATA_QUALITY_SAP_ORDERS,
  SORT_DATA_QUALITY_SAP_ORDERS,
  FILTER_DATA_QUALITY_SAP_ORDERS,
  GET_DATA_QUALITY_SAP_ORDERS_BULK,
  SORT_HWS_SNS_TRAIL,
  FILTER_HWS_SNS_TRAIL,
  GET_HWS_SNS_TRAIL,
  GET_HWS_SNS_TRAIL_BULK,
  GET_HWS_SNS_TRAIL_ANALYSIS,
  CALL_HWS_SWAP,
  CLEAN_API_RESPONSE,
  ADD_HWS_SNS_TRAIL_OUT,
  GET_BULK_REPORT,
  SORT_BULK_EXPORT,
  FILTER_BULK_REPORT,
  CHECK_HWS_SWAP,
  CALL_MATERIAL_SWAP,
  SORT_MISSING_SNS_STATUS,
  FILTER_MISSING_SNS_STATUS,
  GET_MISSING_SNS_STATUS,
  GET_MISSING_SNS_STATUS_BULK,
  GET_ORDERS_BULK,
  ACCESS_REQUEST,
  APP_MONITORING,
  GET_MONITORING,
  GET_SFDC_SYNCHRONIZER_MONITORING,
  GET_SFDC_SYNCHRONIZER_MONITORING_BULK,
  FILTER_SFDC_SYNCHRONIZER_MONITORING,
  TRIGGER_SFDC_SYNC,
  GET_ATHENA_DATABASES,
  GET_ATHENA_TABLES,
  GET_ATHENA_COLUMNS,
  START_ATHENA_QUERY,
  POLL_ATHENA_QUERY,
  GET_ATHENA_HISTORY,
  GET_CLIENT_ERRORS,
  GET_CLIENT_ERROR_USERS,
  CLEAN_ATHENA_QUERY,
  GET_MY_PORTAL_QUERY,
  GET_MY_PORTAL_ANALYTICS,
  UPDATE_MY_PORTAL_OBJECT,
  CLEAN_MY_PORTAL,
  GET_UNPROCESSED_ITEMS,
  GET_UNPROCESSED_ITEM,
  RESEND_UNPROCESSED_ITEM,
  CLEAN_UNPROCESSED_ITEM,
} from "../actions";
import { LOADING } from "../../global/actions";

import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Papa from "papaparse";

// Default ordering for the HWS SNs trail list: most recent arrival date first
// (display the last first). Records without an arrival date are pushed to the end.
const sortHwsSnsTrailByArrivalDateDesc = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return [...rows].sort((a, b) => {
    const dateA = a?.hws_in_arrival_date
      ? moment(a.hws_in_arrival_date).valueOf()
      : -Infinity;
    const dateB = b?.hws_in_arrival_date
      ? moment(b.hws_in_arrival_date).valueOf()
      : -Infinity;
    return dateB - dateA;
  });
};

// TODO GLOBAL
const initialState = {
  parameters: {
    materials: {},
    contracts: {},
    orders: {},
    placeholderMaterials: {},
    serialNumbers: {},
    systems: {},
    systemApplications: {},
    licenses: {},
    dataQualitySapOrders: {},
    hwsSnsTrail: {},
    hwsSnsTrailAnalysis: {},
    apiResponse: {},
    bulkReports: {},
    missingSnsStatus: {},
    appMonitoring: {},
    sfdcSynchronizerMonitoring: {},
    total_orders: 0,
  },
  sfdcSynchronizerMonitoring: [],
  filteredSfdcSynchronizerMonitoring: [],
  athenaDatabases: [],
  athenaTables: [],
  athenaColumns: [],
  athenaQueryStart: null,
  athenaQueryResult: null,
  athenaHistory: [],
  clientErrors: [],
  clientErrorUsers: [],
  myPortalQueryResult: null,
  myPortalAnalytics: null,
  myPortalObjectUpdate: null,
  unprocessedItems: null,
  unprocessedItem: null,
  unprocessedItemResend: null,
};

// TODO GLOBAL
function downloadBulkResult(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

// TODO GLOBAL
const getNestedValueFromString = (from, ...selectors) =>
  [...selectors].map((s) =>
    s
      .replace(/\[([^\[\]]*)\]/g, ".$1.")
      .split(".")
      .filter((t) => t !== "")
      .reduce((prev, cur) => prev && prev[cur], from),
  );

function dynamoReducer(state = initialState, action) {
  if (action?.type !== "SET_USER_SESSION") {
    console.log("reducer action", action);
  }
  switch (action.type) {
    case LOADING:
      break;
    default:
      state.loading = false;
      break;
  }
  if (state.errors) {
    delete state.errors;
  }
  state.errors = action.errors;
  switch (action.type) {
    case FILTER_ORDERS:
      if (!state.orders) {
        state.orders = [];
      }
      let filterOrderParams = action.data;
      let filteredOrders = [];

      let newOrders = state.orders.filter((c) => {
        if (filterOrderParams?.orderId?.length > 0) {
          for (let orderId of filterOrderParams?.orderId) {
            if (!c?.order_id.startsWith(orderId)) {
              return false;
            }
          }
        }
        if (filterOrderParams?.orderLine?.length > 0) {
          for (let orderLine of filterOrderParams?.orderLine) {
            if (!c?.order_line.startsWith(orderLine)) {
              return false;
            }
          }
        }
        return true;
      });
      filteredOrders = filteredOrders.concat(newOrders);

      state = Object.assign({}, state, { filteredOrders });
      return state;

    case SORT_SERIAL_NUMBERS:
      const serialNumbersParam = action.data.sortParameter;
      const serialNumbersDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredSerialNumbers?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, serialNumbersParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, serialNumbersParam)
          .toString()
          ?.toUpperCase();
        if (serialNumbersDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;

    case SORT_ORDERS:
      const orderParam = action.data.sortParameter;
      const orderDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredOrders?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, orderParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, orderParam)
          .toString()
          ?.toUpperCase();
        if (orderDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;
    case SORT_DATA_QUALITY_SAP_ORDERS:
      const dataQualitySapOrderParam = action.data.sortParameter;
      const dataQualitySapOrderDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredDataQualitySapOrders?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, dataQualitySapOrderParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, dataQualitySapOrderParam)
          .toString()
          ?.toUpperCase();
        if (dataQualitySapOrderDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;
    case SORT_HWS_SNS_TRAIL:
      const hwsSnsTrailParam = action.data.sortParameter;
      const hwsSnsTrailDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredHwsSnsTrail?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, hwsSnsTrailParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, hwsSnsTrailParam)
          .toString()
          ?.toUpperCase();
        if (hwsSnsTrailDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;
    case SORT_MISSING_SNS_STATUS:
      const missingSnsStatusParam = action.data.sortParameter;
      const missingSnsStatusDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredMissingSnsStatus?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, missingSnsStatusParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, missingSnsStatusParam)
          .toString()
          ?.toUpperCase();
        if (missingSnsStatusDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;
    case FILTER_HWS_SNS_TRAIL:
      if (!state.hwsSnsTrail) {
        state.hwsSnsTrail = [];
      }
      let filterHwsSnsTrailParams = action.data;
      let filteredHwsSnsTrail = [];

      let newHwsSnsTrail = state.hwsSnsTrail.filter((m) => {
        if (filterHwsSnsTrailParams?.serialNumbers?.length > 0) {
          for (let serialNumber of filterHwsSnsTrailParams?.serialNumbers) {
            if (!m?.serial_number_hws_in?.startsWith(serialNumber)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.partNumbers?.length > 0) {
          for (let partNumber of filterHwsSnsTrailParams?.partNumbers) {
            if (!m?.part_number_hws_in?.startsWith(partNumber)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.soldTos?.length > 0) {
          for (let soldTo of filterHwsSnsTrailParams?.soldTos) {
            if (!m?.applicant_id_hws_in?.startsWith(soldTo)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.businessPartners?.length > 0) {
          for (let businessPartner of filterHwsSnsTrailParams?.businessPartners) {
            if (!m?.business_partner_hws_in?.startsWith(businessPartner)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.supportPartners?.length > 0) {
          for (let supportPartner of filterHwsSnsTrailParams?.supportPartners) {
            if (!m?.support_partner_hws_in?.startsWith(supportPartner)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.endCustomerIds?.length > 0) {
          for (let endCustomerId of filterHwsSnsTrailParams?.endCustomerIds) {
            if (!m?.end_customer_hws_in?.startsWith(endCustomerId)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.bundleReferences?.length > 0) {
          for (let bundleReference of filterHwsSnsTrailParams?.bundleReferences) {
            if (!m?.bundle_reference_hws_in?.startsWith(bundleReference)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.orderId?.length > 0) {
          for (let orderId of filterHwsSnsTrailParams?.orderId) {
            if (!m?.hws_order_id?.startsWith(orderId)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.orderLine?.length > 0) {
          for (let orderLine of filterHwsSnsTrailParams?.orderLine) {
            if (!m?.hws_base_order_line?.startsWith(orderLine)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.status?.length > 0) {
          for (let status of filterHwsSnsTrailParams?.status) {
            if (!m?.status?.startsWith(status)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.swap_date?.length > 0) {
          for (let swap_date of filterHwsSnsTrailParams?.swap_date) {
            if (!m?.swap_date?.startsWith(swap_date)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.replaced_by?.length > 0) {
          for (let replaced_by of filterHwsSnsTrailParams?.replaced_by) {
            if (!m?.replaced_by?.startsWith(replaced_by)) {
              return false;
            }
          }
        }
        if (filterHwsSnsTrailParams?.filterCreationDateStart) {
          if (
            !moment(filterHwsSnsTrailParams.filterCreationDateStart).isBefore(
              moment(m.hws_in_arrival_date),
            )
          ) {
            return false;
          }
        }
        return true;
      });
      filteredHwsSnsTrail = filteredHwsSnsTrail.concat(newHwsSnsTrail);
      filteredHwsSnsTrail = sortHwsSnsTrailByArrivalDateDesc(filteredHwsSnsTrail);

      state = Object.assign({}, state, { filteredHwsSnsTrail });
      return state;
    case FILTER_MISSING_SNS_STATUS:
      if (!state.missingSnsStatus) {
        state.missingSnsStatus = [];
      }
      let missingSnsStatusParams = action.data;
      let filteredMissingSnsStatus = [];

      let newMissingSnsStatus = state.missingSnsStatus.filter((m) => {
        if (missingSnsStatusParams?.serialNumbers?.length > 0) {
          for (let serialNumber of missingSnsStatusParams?.serialNumbers) {
            if (!m?.serial_number?.startsWith(serialNumber)) {
              return false;
            }
          }
        }
        if (missingSnsStatusParams?.partNumbers?.length > 0) {
          for (let partNumber of missingSnsStatusParams?.partNumbers) {
            if (!m?.part_number?.startsWith(partNumber)) {
              return false;
            }
          }
        }
        if (missingSnsStatusParams?.tags?.length > 0) {
          for (let tag of missingSnsStatusParams?.tags) {
            if (!m?.tag?.startsWith(tag)) {
              return false;
            }
          }
        }
        if (missingSnsStatusParams?.status?.length > 0) {
          for (let status of missingSnsStatusParams?.status) {
            if (!m?.sn_status?.startsWith(status)) {
              return false;
            }
          }
        }
        return true;
      });
      filteredMissingSnsStatus =
        filteredMissingSnsStatus.concat(newMissingSnsStatus);

      state = Object.assign({}, state, { filteredMissingSnsStatus });
      return state;
    case FILTER_SERIAL_NUMBERS:
      if (!state.serialNumbers) {
        state.serialNumbers = [];
      }
      let filterSerialNumberParams = action.data;
      let filteredSerialNumbers = [];

      let newSerialNumbers = state.serialNumbers.filter((m) => {
        if (filterSerialNumberParams?.serialNumbers?.length > 0) {
          for (let serialNumber of filterSerialNumberParams?.serialNumbers) {
            if (!m?.serial_number.startsWith(serialNumber)) {
              return false;
            }
          }
        }
        if (filterSerialNumberParams?.partNumbers?.length > 0) {
          for (let partNumber of filterSerialNumberParams?.partNumbers) {
            if (!m?.part_number.startsWith(partNumber)) {
              return false;
            }
          }
        }
        if (filterSerialNumberParams?.soldTos?.length > 0) {
          for (let soldTo of filterSerialNumberParams?.soldTos) {
            if (!m?.sold_to.startsWith(soldTo)) {
              return false;
            }
          }
        }
        if (filterSerialNumberParams?.orderId?.length > 0) {
          for (let orderId of filterSerialNumberParams?.orderId) {
            if (!m?.order_id.startsWith(orderId)) {
              return false;
            }
          }
        }
        if (filterSerialNumberParams?.orderLine?.length > 0) {
          for (let orderLine of filterSerialNumberParams?.orderLine) {
            if (!m?.order_line.startsWith(orderLine)) {
              return false;
            }
          }
        }
        if (filterSerialNumberParams?.filterShippingDateStart) {
          if (
            !moment(filterSerialNumberParams.filterShippingDateStart).isBefore(
              moment(m.shipping_date),
            )
          ) {
            return false;
          }
        }
        if (filterSerialNumberParams?.filterShippingDateEnd) {
          if (
            !moment(filterSerialNumberParams.filterShippingDateEnd).isAfter(
              moment(m.shipping_date),
            )
          ) {
            return false;
          }
        }
        if (filterSerialNumberParams?.filterExtractionDateStart) {
          if (
            !moment(
              filterSerialNumberParams.filterExtractionDateStart,
            ).isBefore(moment(m.extraction_date))
          ) {
            return false;
          }
        }
        if (filterSerialNumberParams?.filterExtractionDateEnd) {
          if (
            !moment(filterSerialNumberParams.filterExtractionDateEnd).isAfter(
              moment(m.extraction_date),
            )
          ) {
            return false;
          }
        }
        return true;
      });
      filteredSerialNumbers = filteredSerialNumbers.concat(newSerialNumbers);

      state = Object.assign({}, state, { filteredSerialNumbers });
      return state;
    case FILTER_DATA_QUALITY_SAP_ORDERS:
      if (!state.dataQualitySapOrders) {
        state.dataQualitySapOrders = [];
      }
      let filterDataQualitySapOrdersParams = action.data;
      let filteredDataQualitySapOrders = [];
      let newDataQualitySapOrders = state.dataQualitySapOrders.filter((m) => {
        if (filterDataQualitySapOrdersParams?.partNumbers?.length > 0) {
          for (let partNumber of filterDataQualitySapOrdersParams?.partNumbers) {
            if (!m?.part_number.startsWith(partNumber)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.soldTos?.length > 0) {
          for (let soldTo of filterDataQualitySapOrdersParams?.soldTos) {
            if (!m?.sold_to.startsWith(soldTo)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.status?.length > 0) {
          for (let status of filterDataQualitySapOrdersParams?.status) {
            if (!m?.status?.startsWith(status)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.orderId?.length > 0) {
          for (let orderId of filterDataQualitySapOrdersParams?.orderId) {
            if (!m?.order_id.startsWith(orderId)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.deliveryId?.length > 0) {
          for (let deliveryId of filterDataQualitySapOrdersParams?.deliveryId) {
            if (!m?.delivery_id?.startsWith(deliveryId)) {
              return false;
            }
          }
        }
        if (
          filterDataQualitySapOrdersParams?.shipConfirmationDate?.length > 0
        ) {
          for (let shipConfirmationDate of filterDataQualitySapOrdersParams?.shipConfirmationDate) {
            if (!m?.ship_confirmation_date?.startsWith(shipConfirmationDate)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.hub?.length > 0) {
          for (let hub of filterDataQualitySapOrdersParams?.hub) {
            if (!m?.hub?.startsWith(hub)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.orderLine?.length > 0) {
          for (let orderLine of filterDataQualitySapOrdersParams?.orderLine) {
            if (!m?.order_line.startsWith(orderLine)) {
              return false;
            }
          }
        }
        if (filterDataQualitySapOrdersParams?.filterCreationDateStart) {
          if (
            !moment(
              filterDataQualitySapOrdersParams.filterCreationDateStart,
            ).isBefore(moment(m.creation_date))
          ) {
            return false;
          }
        }
        if (filterDataQualitySapOrdersParams?.filterCreationDateEnd) {
          if (
            !moment(
              filterDataQualitySapOrdersParams.filterCreationDateEnd,
            ).isAfter(moment(m.creation_date))
          ) {
            return false;
          }
        }
        return true;
      });
      filteredDataQualitySapOrders = filteredDataQualitySapOrders.concat(
        newDataQualitySapOrders,
      );
      state = Object.assign({}, state, { filteredDataQualitySapOrders });
      return state;

    case GET_ORDERS:
      console.log("action", action);
      if (action.data.page !== 1) {
        // Append new orders to existing filteredOrders
        state = Object.assign({}, state, {
          orders: [...state.orders, ...action.orders],
          filteredOrders: [...state.filteredOrders, ...action.orders],
          total_orders: action.total_count,
        });
      } else {
        // Replace filteredOrders if it's the first page
        state = Object.assign({}, state, {
          orders: action.orders,
          filteredOrders: action.orders,
          total_orders: action.total_count,
        });
      }
      return state;
    case GET_SERIAL_NUMBERS:
      state = Object.assign({}, state, {
        serialNumbers: action.serialNumbers,
        filteredSerialNumbers: action.serialNumbers,
      });
      return state;
    case GET_DATA_QUALITY_SAP_ORDERS:
      state = Object.assign({}, state, {
        dataQualitySapOrders: action.dataQualitySapOrders,
        filteredDataQualitySapOrders: action.dataQualitySapOrders,
      });
      return state;
    case GET_HWS_SNS_TRAIL:
      let localHwsSnsTrail = action.hwsSnsTrail;
      if (action.data.preserve_state && localHwsSnsTrail) {
        const existingIdentifiers = new Set(
          localHwsSnsTrail.map((item) => item.SK),
        );

        state.hwsSnsTrail.forEach((item) => {
          if (!existingIdentifiers.has(item.SK)) {
            localHwsSnsTrail.push(item);
          }
        });
      }
      state = Object.assign({}, state, {
        hwsSnsTrail: localHwsSnsTrail,
        filteredHwsSnsTrail: sortHwsSnsTrailByArrivalDateDesc(localHwsSnsTrail),
      });

      return state;
    case GET_MISSING_SNS_STATUS:
      if (!state.missingSnsStatus) {
        state.missingSnsStatus = [];
      }
      state = Object.assign({}, state, {
        missingSnsStatus: action.missingSnsStatus,
        filteredMissingSnsStatus: action.missingSnsStatus,
      });
      return state;
    case GET_ORDERS_BULK:
      state = Object.assign({}, state);
      return state;
    case GET_MISSING_SNS_STATUS_BULK:
      state = Object.assign({}, state);
      return state;
    case GET_SFDC_SYNCHRONIZER_MONITORING_BULK:
      state = Object.assign({}, state);
      return state;
    case TRIGGER_SFDC_SYNC:
      state = Object.assign({}, state);
      return state;
    case ADD_HWS_SNS_TRAIL_OUT:
      let hwsSnTrailOut = action.hwsSnTrailOut;
      let newHwsSnsTrailOut = [hwsSnTrailOut];
      state.hwsSnsTrail.forEach((item) => {
        if (
          !item?.local_placeholder_id ||
          item.serial_number_hws_out !== hwsSnTrailOut?.serial_number_hws_out
        ) {
          newHwsSnsTrailOut.push(item);
        }
      });
      state = Object.assign({}, state, {
        hwsSnsTrail: newHwsSnsTrailOut,
        filteredHwsSnsTrail: newHwsSnsTrailOut,
      });
      return state;
    case GET_HWS_SNS_TRAIL_BULK:
      state = Object.assign({}, state);
      return state;
    case GET_HWS_SNS_TRAIL_ANALYSIS:
      state = Object.assign({}, state, {
        hwsSnsTrailAnalysis: action.hwsSnsTrailAnalysis || [],
      });
      return state;
    case GET_DATA_QUALITY_SAP_ORDERS_BULK:
      if (action.errors) {
        console.log("ERROR", action.errors);
        state = Object.assign({}, state);
        return state;
      }
      if (action.bulkResponse) {
        const parsedDataQualitySapOrders = Papa.unparse(action.bulkResponse, {
          header: true,
        });
        const encodedDataQualitySapOrders = new TextEncoder().encode(
          parsedDataQualitySapOrders,
        );
        const dataQualitySapOrdersBlob = new Blob(
          [encodedDataQualitySapOrders],
          { type: "text/csv" },
        );
        downloadBulkResult(dataQualitySapOrdersBlob, uuidv4(), ".csv");
      }
      state = Object.assign({}, state);
      return state;
    case CALL_MATERIAL_SWAP:
      if (action.errors) {
        state = Object.assign({}, state, {
          apiResponse: { message: action.errors, source: "CALL_MATERIAL_SWAP" },
        });
        return state;
      }
      state = Object.assign({}, state, {
        apiResponse: { message: "Success", source: "CALL_MATERIAL_SWAP" },
      });
      return state;
    case CALL_HWS_SWAP:
      if (action.errors) {
        state = Object.assign({}, state, {
          apiResponse: { message: action.errors, source: "CALL_HWS_SWAP" },
        });
        return state;
      }
      state = Object.assign({}, state, {
        apiResponse: { message: "Success", source: "CALL_HWS_SWAP" },
      });
      return state;
    case CHECK_HWS_SWAP:
      if (action.errors) {
        state = Object.assign({}, state, {
          apiResponse: { message: action.errors, source: "CHECK_HWS_SWAP" },
        });
        return state;
      }
      state = Object.assign({}, state, {
        apiResponse: { message: "Success", source: "CHECK_HWS_SWAP" },
      });
      return state;
    case CLEAN_API_RESPONSE:
      state = Object.assign({}, state, { apiResponse: null });
      return state;
    case GET_BULK_REPORT:
      state = Object.assign({}, state, {
        bulkReports: action.bulkReports,
        filteredBulkReports: action.bulkReports,
      });
      return state;
    case SORT_BULK_EXPORT:
      const bulkReportParam = action.data.sortParameter;
      const bulkReportDirection = action.data.direction;

      // This makes a direct modification to the state, so no Object.assign is required. Somehow.
      state?.filteredBulkReports?.sort(function (a, b) {
        var textA = getNestedValueFromString(a, bulkReportParam)
          .toString()
          ?.toUpperCase();
        var textB = getNestedValueFromString(b, bulkReportParam)
          .toString()
          ?.toUpperCase();
        if (bulkReportDirection === "ascending") {
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        } else {
          return textA > textB ? -1 : textA < textB ? 1 : 0;
        }
      });
      return state;
    case FILTER_BULK_REPORT:
      if (!state.bulkReports) {
        state.bulkReports = [];
      }
      let filterBulkReportParams = action.data;
      let filteredBulkReports = [];

      let newBulkReports = state.bulkReports.filter((c) => {
        if (filterBulkReportParams?.batchTypes?.length > 0) {
          for (let batchType of filterBulkReportParams?.batchTypes) {
            if (!c?.batch_type.startsWith(batchType)) {
              return false;
            }
          }
        }
        if (filterBulkReportParams?.status?.length > 0) {
          for (let status of filterBulkReportParams?.status) {
            if (!c?.status.startsWith(status)) {
              return false;
            }
          }
        }
        return true;
      });
      filteredBulkReports = filteredBulkReports.concat(newBulkReports);

      state = Object.assign({}, state, { filteredBulkReports });
      return state;
    case ACCESS_REQUEST:
      state = Object.assign({}, state);
      return state;
    case APP_MONITORING:
      state = Object.assign({}, state);
      return state;
    case GET_MONITORING:
      state = Object.assign({}, state, {
        appMonitoring: Object.assign(
          {},
          state.appMonitoring,
          action.appMonitoring,
        ),
      });
      return state;
    case GET_SFDC_SYNCHRONIZER_MONITORING:
      state = Object.assign({}, state, {
        sfdcSynchronizerMonitoring: action.sfdcSynchronizerMonitoring,
        filteredSfdcSynchronizerMonitoring: action.sfdcSynchronizerMonitoring,
      });
      return state;
    case FILTER_SFDC_SYNCHRONIZER_MONITORING: {
      const data = action.data;
      const filtered = (state.sfdcSynchronizerMonitoring ?? []).filter((m) => {
        if (
          data?.elementId &&
          !m?.id?.toLowerCase().includes(data.elementId.toLowerCase())
        )
          return false;
        if (
          data?.detailType &&
          !m?.detail_type?.toLowerCase().includes(data.detailType.toLowerCase())
        )
          return false;
        if (
          data?.objectType &&
          !m?.object_type?.toLowerCase().includes(data.objectType.toLowerCase())
        )
          return false;
        if (
          data?.errorCode &&
          !m?.error_code?.toLowerCase().includes(data.errorCode.toLowerCase())
        )
          return false;
        if (
          data?.errorMessage &&
          !m?.error_message
            ?.toLowerCase()
            .includes(data.errorMessage.toLowerCase())
        )
          return false;
        if (
          data?.sfdcWrite &&
          !m?.sfdc_write
            ?.toString()
            .toLowerCase()
            .includes(data.sfdcWrite.toLowerCase())
        )
          return false;
        if (
          data?.source &&
          !m?.source?.toLowerCase().includes(data.source.toLowerCase())
        )
          return false;
        return true;
      });
      state = Object.assign({}, state, {
        filteredSfdcSynchronizerMonitoring: filtered,
      });
      return state;
    }
    case GET_ATHENA_DATABASES:
      state = Object.assign({}, state, {
        athenaDatabases: action.athenaDatabases ?? [],
      });
      return state;
    case GET_ATHENA_TABLES:
      state = Object.assign({}, state, {
        athenaTables: action.athenaTables ?? [],
      });
      return state;
    case GET_ATHENA_COLUMNS:
      state = Object.assign({}, state, {
        athenaColumns: action.athenaColumns ?? [],
      });
      return state;
    case START_ATHENA_QUERY:
      state = Object.assign({}, state, {
        athenaQueryStart: action.athenaQueryStart ?? null,
        athenaQueryResult: null,
      });
      return state;
    case POLL_ATHENA_QUERY:
      state = Object.assign({}, state, {
        athenaQueryResult: action.athenaQueryResult ?? null,
      });
      return state;
    case GET_ATHENA_HISTORY:
      state = Object.assign({}, state, {
        athenaHistory: action.athenaHistory ?? [],
      });
      return state;
    case GET_CLIENT_ERRORS:
      state = Object.assign({}, state, {
        clientErrors: action.clientErrors ?? [],
      });
      return state;
    case GET_CLIENT_ERROR_USERS:
      state = Object.assign({}, state, {
        clientErrorUsers: action.clientErrorUsers ?? [],
      });
      return state;
    case CLEAN_ATHENA_QUERY:
      // Only clear the query run/result. Columns belong to the selected table
      // and must survive a query so the user can keep editing the builder.
      state = Object.assign({}, state, {
        athenaQueryStart: null,
        athenaQueryResult: null,
      });
      return state;
    case GET_MY_PORTAL_QUERY:
      state = Object.assign({}, state, {
        myPortalQueryResult: action.myPortalQueryResult ?? null,
      });
      return state;
    case GET_MY_PORTAL_ANALYTICS:
      state = Object.assign({}, state, {
        myPortalAnalytics: action.myPortalAnalytics ?? null,
      });
      return state;
    case UPDATE_MY_PORTAL_OBJECT:
      state = Object.assign({}, state, {
        myPortalObjectUpdate: action.myPortalObjectUpdate ?? null,
      });
      return state;
    case CLEAN_MY_PORTAL:
      state = Object.assign({}, state, {
        myPortalQueryResult: null,
        myPortalAnalytics: null,
        myPortalObjectUpdate: null,
      });
      return state;
    case GET_UNPROCESSED_ITEMS:
      state = Object.assign({}, state, {
        unprocessedItems: action.unprocessedItems ?? null,
      });
      return state;
    case GET_UNPROCESSED_ITEM:
      state = Object.assign({}, state, {
        unprocessedItem: action.unprocessedItem ?? null,
      });
      return state;
    case RESEND_UNPROCESSED_ITEM:
      state = Object.assign({}, state, {
        unprocessedItemResend: action.unprocessedItemResend ?? null,
      });
      return state;
    case CLEAN_UNPROCESSED_ITEM:
      state = Object.assign({}, state, {
        unprocessedItem: null,
        unprocessedItemResend: null,
      });
      return state;
    default:
      return state;
  }
  return state;
}

export default dynamoReducer;
